function NotesIcon({ className }) {
  return (
    <svg viewBox="0 0 16 16" className={className} fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" aria-hidden="true">
      <path d="M4 2.4h6.1L13.6 6v7.6H4V2.4Z" />
      <path d="M10.1 2.4V6h3.5" />
      <path d="M6 8.1h4.4M6 10.2h4.4M6 12.3h3" />
    </svg>
  );
}

export default function CommentsNotesButton({ open = false, onClick, size = 'sm' }) {
  const box = size === 'lg' ? 'h-8 w-8' : 'h-6 w-6';
  const icon = size === 'lg' ? 'h-4 w-4' : 'h-3.5 w-3.5';

  return (
    <div className="relative inline-flex">
      <button
        type="button"
        aria-label="Комментарии"
        aria-expanded={open}
        title="Комментарии"
        onClick={onClick}
        className={`peer inline-flex ${box} items-center justify-center rounded-full border transition ${
          open
            ? 'border-sky-400/50 bg-sky-400/10 text-sky-700 dark:text-sky-200'
            : 'border-slate-300 text-slate-500 hover:border-sky-400 hover:text-sky-700 dark:border-slate-700 dark:text-slate-400 dark:hover:text-sky-200'
        }`}
      >
        <NotesIcon className={icon} />
      </button>
      <span className="pointer-events-none absolute left-1/2 top-full z-[60] mt-1 -translate-x-1/2 whitespace-nowrap rounded-md border border-slate-300 bg-white px-2 py-1 text-[11px] text-slate-800 opacity-0 shadow-lg peer-hover:opacity-100 peer-focus:opacity-100 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200">
        Комментарии
      </span>
    </div>
  );
}
